<template>
  <div class="ds--data-empty" @click="fnClick">
    <div class="empty-icon" :style="iconStyle">
      <svg-icon :icon-class="svgIcon"></svg-icon>
    </div>
    <div class="empty-text" :style="textStyle">
      <span>{{text}}</span>
    </div>
  </div>
</template>
<script>
import Common from "@/utils/common";
export default {
  name: "DsDataEmpty",
  props: {
    //svg-icon 名称
    svgIcon: {
      type: String,
      default: "icon-failure-retry",
    },
    //icon大小（font-size，传入px值，自动转换为vw）
    iconSize: {
      type: Number,
      default: 150,
    },
    //描述文字
    text: {
      type: String,
      default: "暫未找到任何記錄，可刷新重試",
    },
    //描述文字大小（font-size，传入px值，自动转换为vw）
    textSize: {
      type: Number,
      default: 14,
    },
    //描述文字颜色
    textColor: {
      type: String,
      default: "#cfcfcf",
    },

    //@retry 事件：点击后触发
  },
  data() {
    return {
      iconStyle: {},
      textStyle: {},
    };
  },
  mounted() {
    let _iconStyle = {
      "font-size": `${Common.fnPxToViewPort(this.iconSize)}vw`,
    };
    this.iconStyle = _iconStyle;

    let _textStyle = {
      "font-size": `${Common.fnPxToViewPort(this.textSize)}vw`,
      color: this.textColor,
    };
    this.textStyle = _textStyle;
  },
  methods: {
    fnClick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss" scoped>
.ds--data-empty {
  height: 100%;
  width: 100%;
  position: absolute;
  overflow: hidden;
  box-sizing: border-box;
  user-select: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .empty-icon {
    // margin-top: -100px;
  }
  .empty-text {
    text-align: center;
    padding: 0px 25px;
    line-height: 21px;
  }
}
</style>
